import { createSelector } from 'reselect'

const getLessonsData = state => state.storefront.visitor.lessons
const getOwnerId = state => state.storefront.visitor.data.ownerId

const storefrontVisitorLessonsListQuery = createSelector(
	[getLessonsData, getOwnerId],
	(lessonsData, ownerId) => ({
		page: lessonsData.page,
		more: lessonsData.more,
		ownerId,
	})
)

export default storefrontVisitorLessonsListQuery
